import { QueryClient, dehydrate } from '@tanstack/react-query';
export const staticCoreApp = ({ context }) => {
    const queryClient = new QueryClient();
    const slug = context.params?.slug?.toString();
    const getStaticProps = () => {
        const dehydratedState = dehydrate(queryClient);
        return {
            dehydratedState,
        };
    };
    return {
        getStaticProps,
        queryClient,
        slug: slug ?? '',
        locale: context.locale ?? '',
    };
};
